import { inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/active-storefront.action';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { StorefrontsService } from '../../services';
import { SetDefaultTheme, SetTheme } from 'src/app/store/actions';

export const loadActiveStorefront = createEffect(
  (actions$ = inject(Actions), service = inject(StorefrontsService)) => {
    return actions$.pipe(
      ofType(actions.LoadActiveStorefront),
      switchMap(() =>
        service.getActiveStorefront().pipe(
          map(storefront => {
            return actions.LoadActiveStorefrontSuccess({ storefront });
          }),
          catchError(error => of(actions.LoadActiveStorefrontFail({ error })))
        )
      )
    );
  },
  { functional: true }
);

//export const setActiveStorefrontTheme = createEffect(
//  (actions$ = inject(Actions), service = inject(StorefrontsService)) => {
//    return actions$.pipe(
//      ofType(actions.LoadActiveStorefrontSuccess),
//      switchMap((activeStorefront) =>
//        // trigger action in theme store
//        SetTheme({ theme: activeStorefront.storefront.defaultTheme})
//      )
//    );
//  },
//  { functional: true }
//);

export const LoadActiveStorefrontSuccessEffect = createEffect(
  (actions$ = inject(Actions), service = inject(StorefrontsService)) => {
    return actions$.pipe(
      ofType(actions.LoadActiveStorefrontSuccess),
      //tap(({ storefront }) => {
      //  console.log('storefront', storefront);
      //}),
      map(({ storefront }) => {
        return SetDefaultTheme({ theme: storefront.defaultTheme || '' });
      })
    );
  },
  { functional: true }
);
